import { axios } from "../../lib/axios";

export const DeleteTeam = (TeamId: string) => {
    return axios.delete(`/team/${TeamId}`)
        .then(response => response.data);
};